// Olympe
import { QueryResult } from 'olympe';

// Rxjs
import { tap, combineLatest, map } from 'rxjs';

// Internal
import { warn, fromJson } from './helpers';

/**
 * Init the internal data state, make sure it is an array
 * @param {!BrickContext} $ 
 * @param {!Observable} _reload
 * @return {!Observable}
 */
export function initData($, _reload) {
    // Listen to the data and for any refresh
    return combineLatest([
        $.observe('Data', false),
        _reload
    ])

        // Default values
        .pipe(map(([data]) => data ? data : []))

        // Transform to an array
        .pipe(map(data => {
            // The data is already an array
            if (Array.isArray(data)) {
                return data;
            }

            // QueryResult case
            if (data instanceof QueryResult) {
                return data.toArray();
            }

            // JSON case
            if (typeof data === 'string') {
                const [json, error] = fromJson(data);
                if (!error && Array.isArray(json)) {
                    return json;
                }
            }

            // Type is not supported
            warn('the `Data` property is not convertible to an array');
            return [];
        }))
        
        // Set the transformed data into _Data
        .pipe(tap(data => $.set('_rgData', data)));
}

